(function ($, config) {
	//Source : https://developers.google.com/maps/documentation/javascript/adding-a-google-map
	const $mapDiv = $("#map");
	if ($mapDiv.length) {
		// Create the script tag, set the appropriate attributes
		const script = document.createElement('script');
		const googleApiToken = config['googleApi'];
		script.src = 'https://maps.googleapis.com/maps/api/js?key=' + googleApiToken + '&callback=initMap';
		script.defer = true;
		window.initMap = function () {
			// Attach your callback function to the `window` object
			const pingMark = {lat: parseFloat($mapDiv.data("lat")), lng: parseFloat($mapDiv.data("lng"))};
			// noinspection JSUnresolvedVariable
			const map = new google.maps.Map(
				$mapDiv[0],
				{
					zoom: parseFloat($mapDiv.data("zoom")),
					center: pingMark,
				});

      // noinspection JSUnresolvedVariable,JSUnresolvedFunction
      new google.maps.marker.AdvancedMarkerElement({
        position: pingMark,
        map: map,
      });
    };
    document.head.appendChild(script);
  }
})(jQuery, afgcEventSingle);

(function ($) {
	if (!(CSS.supports && CSS.supports('position', 'sticky'))) {
		return;
	}

	const $topbar = $('.event-topbar');
	const $image = $('.event-image');

	/* below 600px wide wp admin bar is absolutly posititoned */
	if ($('#wpadminbar').css('position') === 'absolute') {
		$topbar.css('top', '0');
	}
	let topOffset = 380;
	if ($image.length) {
		topOffset += $image.height();
	}

	const debounce = (func, wait, immediate) => {
		let timeout;
		return () => {
			const context = this, args = arguments;
			const later = () => {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			const callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
	let topbarfixed = false;
	$(window).on('scroll', debounce(() => {
		const scroll = $(window).scrollTop();
		if (scroll >= topOffset) {
			if (!topbarfixed) {
				topbarfixed = true;
				$topbar.addClass('stuck');
				window.scrollTo(0, scroll); /* avoid scroll when body height change */
			}
		} else {
			if (topbarfixed) {
				topbarfixed = false;
				$topbar.removeClass('stuck');
				window.scrollTo(0, scroll); /* avoid scroll when body height change */
			}
		}
	}, 100)).trigger('scroll');
})(jQuery);
